<template>
  <v-dialog v-model="show" persistent max-width="600px">
    <v-card>
      <v-toolbar color="light-green lighten-3" dark>
        <v-toolbar-title class="headline"
          >Lägg till extraanpassning</v-toolbar-title
        >
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-flex>
            <v-flex>
              <v-text-field
                label="Namn"
                hint="Namn på eleven"
                required
                v-model="NewExtra.name"
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-select
                v-model="NewExtra.class"
                :items="classes"
                item-text="[0]"
                item-value="[1]"
                attach
                chips
                label="Klass"
                hint="Vilken klass går eleven i?"
                persistent-hint
              ></v-select>
            </v-flex>

            <v-flex>
              <v-select
                v-model="categories"
                :items="kategorier"
                attach
                multiple
                chips
                label="Kategori"
                hint="Vilken kategori ligger extraanpassningen inom?"
                persistent-hint
              ></v-select>
            </v-flex>
            <v-flex v-for="(kat, index) in underkategorier" :key="kat.name">
              <v-select
                v-if="categories.includes(kat.name)"
                v-model="adaptations[index]"
                :items="underkategorier[index].choices"
                attach
                multiple
                chips
                label="Anpassning"
                persistent-hint
                :hint="underkategorier[index].hint"
              ></v-select>
            </v-flex>
         
          </v-flex>
        </v-container>
      </v-card-text>
      <v-card-actions class="mtop">
        <v-spacer></v-spacer>
        <v-btn dark color="red darken-1" @click="show = false"> Stäng </v-btn>
        <v-btn
          color="green lighten-1"
          text
          dark
          @click="change()"
          v-if="Oldclass != null"
        >
          Uppdatera extraanpassning
        </v-btn>
        <v-btn color="green lighten-1" text dark @click="change()" v-else>
          Skapa extraanpassning
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "newExtra",

  watch: {
    categories: function (val) {
      // if (this.adaptations.length > this.categories.length) {
      //   for (let i = this.categories.length; i < this.adaptations.length; i++) {
      //     this.adaptations.pop();
      //   }
      // } else if (this.categories.length == this.adaptations.length) {
      // } else {
      //   for (let i = this.adaptations.length; i < val.length; i++) {
      //     this.adaptations.push([]);
      //   }
      // }
      // //console.log(this.adaptations);
    },
    // needs: function (val) {
    //   if (this.underneeds.length > this.needs.length) {
    //     for (let i = this.needs.length; i < this.underneeds.length; i++) {
    //       this.underneeds.pop();
    //     }
    //   } else if (this.needs.length == this.underneeds.length) {
    //   } else {
    //     for (let i = this.underneeds.length; i < val.length; i++) {
    //       this.underneeds.push([]);
    //     }
    //   }

      // this.underneeds =[]
      // for (let i = 0; i < this.needs.length; i++) {
      //   this.underneeds.push([])
      // }
    // },
  },

  computed: {
    show: {
      get() {
        if (this.Oldclass != null ) {
          if (this.name!= this.Oldclass.name) {
            
          // //console.log(this.Oldclass)
          this.name=this.Oldclass.name
//  this.categories=[]
  // this.adaptations=[]
      this.categories= []
      this.adaptations= [[],[],[],[],[],[],[]]
          this.NewExtra = this.Oldclass;
          let adaptations =this.Oldclass.adaptations.split(',')
          adaptations= adaptations.filter(n => n)
          let abc= adaptations.map(a=>a.substring(0, 1))
            //console.log(adaptations)
            this.oldAdoptations= adaptations;
            abc = [...new Set(abc)];
          abc.forEach(adap => {
            //console.log(adap)
        this.categories.push(this.kategorier[this.letters.indexOf(adap)])   
          });
                    adaptations.forEach(adap => {
                      let bokstav=this.letters.indexOf(adap[0])
        this.adaptations[bokstav].push(this.underkategorier[bokstav].choices[adap[1]])   
          });

          //  //console.log(  this.adaptations)
          // //console.log(  this.categories)

          // this.categories=  [...new Set(this.categories)];
          // for (let i = 0; i < this.adaptations.length; i++) {
          // this.adaptations[i]=  [...new Set(this.adaptations[i])];            
          // }


          this.update = true;
        }
          }
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },

  created() {
    // if (this.Oldclass != null) {
    //   this.NewExtra = this.Oldclass;
    // }
  },
  props: {
    membernameandId: Array,
    Oldclass: Object,
    schoolId: String,
    classes: Array,
    id: String,
    value: Boolean,
  },
  data() {
    return {
      update: false,
      Specialaccess: "nej",
      behov: [
        "Kompenserande pedagogik",
        "Navigeringsstöd",
        "Energivård",
        "Kompenserande miljö",
      ],
      underbehov: [
        {
          name: "Kompenserande miljö",
          hint: "Komp miljö",
          choices: [
            "Perceptionssanera skolan",
            "Skapa funktionella arbetsplatser",
            "Underlätta i svåra miljöer",
            "Dämpa utmanande beteenden med miljön",
            "Skapa en skolgård för alla",
          ],
        },
      ],
      kategorier: [
        "Kommunikation/Information",
        "Planering/Organisation",
        "Sinnesintryck",
        "Uppmärksamhet",
        "Impulsivitet/aktivitet",
        "Tidsuppfattning",
        "Flexibilitet",
      ],
      underkategorier: [
        {
          name: "Kommunikation/Information",
          hint: "Eleven behöver anpassningar på grund av svårigheter med kommunikation/information",
          choices: [
            "Tydlig skriftlig information",
            "Orienteringskarta över skolan",
            "Skyltar som visar vad som finns var",
            "Fotografier och skyltar på respektive dörr i skolan som visar vad och vem som finns där",
            "Anpassad kommunikation (färre ord, begränsad meningslängd)",
            "Sammanhangsförklaringar (förklara det underförstådda, hur sammanhangskedjan hänger ihop och ge svar på de frågor eleven själv har svårt att ställa)",
            "Hjälpmedel för att be om hjälp (t.ex. ett ”behöver hjälp”-kort på bänken)",
            "Visuellt samtalsstöd (sociala berättelser, ritprat, dataprat, samtalsmatta(för mer info besök www.dart-gbg.org/samtalsmatta) )",
            "Stresstermometer (kunna visa hur stark t .ex. stressen är)",
            "Sociala manus",
            "Smartboard",
            "Smartphone",
          ],
        },
        {
          name: "Planering/Organisation",
          hint: "Eleven behöver anpassningar på grund av svårigheter att planera och organisera",
          choices: ["Att-göra-listor","Hur-göra-listor","Visuella arbetsordningar och planeringslinjer, tidslinjer"
          ,"Visualisera händelser − sammanhangskedjor","Nedbrutna arbetsuppgifter i små tydliga steg","Färgkodning av schema och böcker",
          "Stöd att komma i gång","Stöd att avsluta","Påminnelselistor – auditivt minnesstöd"],
        },
                {
          name: "Sinnesintryck",
          hint: "Eleven behöver anpassningar på grund av annorlunda perception (”intrycksallergi”)",
          choices: ["Krok/skåp längst ut (inte behöva trängas med andra)"," Sitta längst bak/längst fram/närmast dörren i klassrummet","Få använda hörselkåpor, mp3, iPod, Audio Comfort-hjälpmedel eller ER-hörselskydd i klassrummet"
          ,"Få använda keps/solglasögon","Skärmvägg","Stol med armstöd (svårt hålla kroppen upprätt längre stunder)",
          "Bolldyna/kilkudde","Särskild kost på grund av annorlunda perception."," Äta i enskilt rum/lugnare plats i matsalen",
          "Tillåtelse att vara inne på raster","Särskilda papper eller pennor"," Skriva med dator i stället för med penna",
          "Möbeltassar på stolar och bänkar (minimera stolskrap)","Sitta långt ifrån fläktsystem/ventilationstrumma","Anpassningar i omklädningsrum och gymnastiksal.",],
                  },
                {
          name: "Uppmärksamhet",
          hint: "Eleven behöver anpassningar på grund av bristande uppmärksamhetsförmåga",
          choices: ["Placering i klassrummet utan distraherande störningsmoment (t.ex. ej vid fönster)","Skärmvägg","Läslinjal","Uppdelade arbetsuppgifter i delmoment","Uppgifter på papper i stället för tjocka böcker","Skriftliga instruktioner på tavla samt bänk"
          ,"Anpassade arbetspass efter hur länge eleven klarar att hålla kvar uppmärksamheten","Tätare pauser","Minnesstöd",
          "Talförstärkare","Övergångsuppgifter","Förståelse för att eleven kan behöva resa på sig och röra sig eller sitta och pillra med något samtidigt som han/hon lyssnar"
          ],  },
                          {
          name: "Impulsivitet/aktivitet",
          hint: "Eleven behöver anpassningar på grund av bristande impulskontroll",
          choices: ["Minimera störande intryck i närheten", "Överenskommelser om att få gå ifrån lektion vid stress",
 "Anpassningar i situationer där man behöver vänta (t.ex. kö till matsal)"
          ],  },
                                    {
          name: "Tidsuppfattning",
          hint: "Eleven behöver anpassningar på grund av bristande tidsuppfattning",
          choices: ["Tidshjälpmedel (t.ex. Time Timer, timstock, timer, timglas)", "Rastschema (uträknat efter vad man hinner under en kvartsrast eller lunchrast)",
          "Överskådliga kalendrar", "Överskådliga tidslinjer"
          ],  },
                                              {
          name: "Flexibilitet",
          hint: "Eleven behöver anpassningar på grund av svårigheter med föreställningsförmåga och/eller av bristande flexibilitet",
          choices: ["Schema som talar om vad som ska hända, när, hur länge, med vem och vad som händer sedan", "Rastschema med förslag på aktiviteter",
          "Stöd av plus- och minuslistor i uppgifter där man ska reflektera eller analysera","Anpassade uppgifter där det krävs föreställningsförmåga att exempelvis kunna föreställa sig hur det är att bo i andra länder, hur det var förr i tiden, hur något kan bli i framtiden",
          "Övergångsuppgifter","Förbereda för att det snart är dags att börja med något respektive att avsluta, t.ex. med hjälp av ett tidshjälpmedel",
          "Undvika förändringar, förberedelser inför förändringar","Tydliga regler och uppdragsbeskrivningar","Ett mjukt och följsamt bemötande av omgivningen",
          "Planering som inbegriper en plan B om en aktivitet inte går att genomföra"
          ],  },
      ],
      NewExtra: {
        schoolId: this.schoolId,
      },
      categories: [],
      adaptations: [[],[],[],[],[],[],[]],
      
     letters: "abcdefghijklmn",
      // underneeds: [],
      locfun: null,
      name: "",
      oldAdoptations: [],
    };
  },

  methods: {
    ...mapActions("extra", ["createExtra", "saveExtra"]),
    ...mapActions(["showSuccessSnackbar"]),

    change() {
      let checkagainstOld= []
      let uAdap = [];
      for (let i = 0; i < this.adaptations.length; i++) {
        let tempAdaptations = [];
        for (let j = 0; j < this.adaptations[i].length; j++) {
          let Lista = this.underkategorier[i].choices;
          let place = Lista.indexOf(this.adaptations[i][j]);
          tempAdaptations.push(this.letters[i] + place);
        }
        uAdap.push(tempAdaptations);
        checkagainstOld.push(tempAdaptations);
      // //console.log(uAdap);
      }
          checkagainstOld= checkagainstOld.flat(Infinity);
//console.log(checkagainstOld)
      // //console.log(uAdap.toString());
      this.NewExtra.adaptations = uAdap.toString();

      if (this.update == false) {
         this.NewExtra.teacherIds=[]
         checkagainstOld.forEach(adap => {
           this.NewExtra.teacherIds.push("")
         });
        //  //console.log(this.NewExtra)
      this.createExtra(this.NewExtra);
      this.showSuccessSnackbar(
        "Extraanpassning för " + this.NewExtra.name + " är skapad!"
      );
                this.NewExtra={        schoolId: this.schoolId}
this.categories=[]
      } else {

       let newteacherIDs=[]
// Fixar så det är rätt teacherids och rätt antal
         if(this.oldAdoptations.length> checkagainstOld.length)
 {
  for (let i = 0; i < this.oldAdoptations.length; i++) {
           if(checkagainstOld.includes(this.oldAdoptations[i]))    
			{
           let place= checkagainstOld.findIndex(b1 => b1 == this.oldAdoptations[i])
           newteacherIDs.splice(place, 0, this.NewExtra.teacherIds[i]);
          
           }
            //  else if(checkagainstOld[i]==null)
          // newteacherIDs.push("")          
          }

 }
 else if(this.oldAdoptations.length< checkagainstOld.length)
 {
   for (let i = 0; i < checkagainstOld.length; i++) {
           if(checkagainstOld.includes(this.oldAdoptations[i]))    
			{
           let place= checkagainstOld.findIndex(b1 => b1 ==this.oldAdoptations[i])
           newteacherIDs.splice(place, 0, this.NewExtra.teacherIds[i]);
           }
           else
          newteacherIDs.push("")          
          }
 }
//console.log(newteacherIDs)
//console.log(this.NewExtra.teacherIds)  
//console.log(this.oldAdoptations)
             //console.log(checkagainstOld)
this.NewExtra.teacherIds=newteacherIDs;

         this.saveExtra(this.NewExtra);
        this.showSuccessSnackbar(
          "Extraanpassning för " + this.NewExtra.name + " är updaterad!"
        );
      }
     

      this.show = false;
    },
  },
};
</script>
<style >
.mtop{
  margin-top: 100px !important;
}
</style>